import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=2ecf2bb5&scoped=true"
import script from "./ColumnChart.vue?vue&type=script&lang=js"
export * from "./ColumnChart.vue?vue&type=script&lang=js"
import style0 from "./ColumnChart.vue?vue&type=style&index=0&id=2ecf2bb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf2bb5",
  null
  
)

export default component.exports